import { Box, Link } from '@mui/material';

export function RegistrationLegalAdminComplete() {
  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Link href="https://admin.fastai.tech" underline="none">
          Влезте в системата
        </Link>
      </Box>
    </>
  );
}
